/** Q5: marks an image the creator put inside the email body rather than attaching it. */
export function InMessageTag() {
  return (
    <span className="shrink-0 rounded-full bg-(--stone-100) px-2 py-[2px] text-[11px] text-muted-foreground">
      In message
    </span>
  );
}
